import Modal from "react-modal";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import UserNameContext from "../../Context/UserNameContext";
import { ScoreContext } from "../../Context/ScoreContext";
import axios from "axios";

export const LoseModal = ({ show, onClose, restartGame }) => {
  const { userName,setUserName } = useContext(UserNameContext);
  const { score, setScore } = useContext(ScoreContext);
  useEffect(() => {
    const storedName = localStorage.getItem("userName");
    if (storedName) setUserName(storedName);

  },[])

  const postVisitorScore = () => {
    axios
      .post("https://findzok.com/api/visitors", {
        id: localStorage.getItem("userId"),
        name: localStorage.getItem("userName"),
        score: score,
      })
      .then((response) => {
        console.log(response);
        localStorage.setItem("userId", response.data.data.id);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  postVisitorScore()
  return (
    <>
      <Modal className="loseModalBox" isOpen={show} onRequestClose={onClose}>
        <div className="container-fluid ">
          <div className="">
            <div className="winModalCotainer">
              <div className="winContent h-screen w-screen overflow-auto pt-16 flex flex-col   ">
                <div className="lg:flex-grow lg:flex justify-center items-center flex-col">
                  <div>
                    <h1 className="py-2">Hard Luck! </h1>
                    <h3 className="placed">Thank You Dr. {userName} for your time.</h3>
                    <h3>Your score is {score}/200</h3>
                  </div>

                  <div className="mt-3">
                    <button onClick={restartGame} className=" playButton mx-2">
                      Play Again
                    </button>
                    <Link to="/choose-theme">
                      <button className="playButton">Return Home </button>
                    </Link>
                  </div>
                </div>
                <Footer />
              </div>
           
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
